import React, { PureComponent } from 'react';
import Styles from '../constants/Styles';
import { isMobile, isTall } from '../vodjs/Utils.js';
import { DRButton } from '../components/DRControls';

import { env } from '../vodjs/settings';
import { disableLongPressBS } from '../constants/Styles';
import { ROBOT_IDLE_STATE } from '../screens/HomeScreen.js';

export const START_GOAL = 'start_goal';
export const END_GOAL = 'end_goal';
export const SENDER_NOTE = 'sender_note';
export const RECIPIENT_NOTE = 'recipient_note';
export const TASK_STATUS = 'status';
export const USER_SUCCESS = 'user_success';

const NOTE_TITLE_FONT_STYLE = { fontWeight: 700, fontSize: 22 };
const NOTE_FONT_STYLE = { fontWeight: 400, fontSize: 20 };
const CLOSE_ICON_NO_FILL = require('../assets/images/close_no_fill.png');
const TICK_ICON_NO_FILL = require('../assets/images/tick_no_fill.png');

const mobile = isMobile();

export const formatDeliveryFromNoteTitle = (dropOffLocation, pickupLocation = 'You') =>
  `Delivery from ${pickupLocation} to ${dropOffLocation}`;

export class UnloadMoxiInstructionWithNoteView extends PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    let { pickupLocation, note } = this.props;
    let title = `Delivery from ${pickupLocation} to You`;
    return (
      <div style={{ ...Styles.container, alignItems: 'center', margin: '30px' }}>
        <div
          style={{
            fontWeight: 700,
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: 36,
          }}
        >
          Please Unload Moxi
        </div>
        <div
          style={{
            fontWeight: 700,
            fontSize: 18,
            textAlign: 'center',
            fontWeight: 'bold',
            marginTop: 16,
          }}
        >
          {`You have locked items`}
        </div>
        <div
          style={{
            fontWeight: 400,
            fontSize: 18,
            marginTop: 16,
          }}
        >
          {`Scan your badge to unlock Moxi's storage, unload and lock, then indicate whether your delivery was successful or not`}
        </div>
        <div style={{ ...NOTE_TITLE_FONT_STYLE, marginTop: 80, textAlign: 'center', fontWeight: 'bold' }}>{title}</div>
        <div style={{ flexDirection: 'row' }}>
          <div style={{ ...NOTE_FONT_STYLE, marginTop: 20, textAlign: 'center' }}>{note}</div>
        </div>
      </div>
    );
  }
}

export class HorizontalButtonPairView extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { buttonSettings, styling } = this.props;

    if (!buttonSettings) return null;

    return (
      <div
        style={{
          ...styling,
          flex: 1,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
          alignItems: 'center',
          textWrap:'nowrap'
        }}
      >
        {buttonSettings.map((buttonSetting, i) => (
          <DRButton
            id={buttonSetting.id}
            key={i}
            style={{ alignSelf: 'center', ...disableLongPressBS, ...buttonSetting.buttonStyling }}
            action={buttonSetting.action}
            phrase={buttonSetting.phrase}
            fontSize={buttonSetting.fontSize}
            fontColor={buttonSetting.fontColor}
            borderColor={buttonSetting.borderColor}
            fillColor={buttonSetting.fillColor}
            height={buttonSetting.height}
            width={buttonSetting.width}
            disabled={buttonSetting.disabled}
          />
        ))}
      </div>
    );
  }
}

export class NotePanelView extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { dropOffLocation, note } = this.props;
    const title = formatDeliveryFromNoteTitle(dropOffLocation);
    return (
      <div style={{ ...Styles.box, ...Styles.shadow3, ...Styles.centeredContent }}>
        <div style={NOTE_TITLE_FONT_STYLE}>{title}</div>
        <div style={{ flexDirection: 'row' }}>
          <div style={NOTE_FONT_STYLE}>{note}</div>
        </div>
        <div style={Styles.centeredContent}>{this.props.children}</div>
      </div>
    );
  }
}

export class DeliveryResultView extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { dropoffUnit, pickupUnit, deliveryFeedback, isSuccessful, confirmAction } = this.props;
    let title = formatDeliveryFromNoteTitle(dropoffUnit, pickupUnit);
    return (
      <div
        style={{
          ...Styles.box,
          ...Styles.centeredContent,
          ...Styles.shadow3,
          width: 387,
          height: 364,
          marginTop: 200,
          alignSelf: 'center',
        }}
      >
        <div
          style={{
            fontWeight: 700,
            fontSize: 24,
          }}
        >
          {title}
        </div>
        <div style={{ flexDirection: 'row', marginTop: 20 }}>
          <div
            style={{
              fontWeight: 400,
              fontSize: 14,
            }}
          >
            {deliveryFeedback}
          </div>
        </div>
        <img
          draggable="false"
          style={{ width: 120, height: 120, marginTop: 100 }}
          source={isSuccessful ? TICK_ICON_NO_FILL.default : CLOSE_ICON_NO_FILL.default}
        />
        <DRButton
          action={confirmAction}
          fontColor={'#8785FF'}
          borderColor={'#8785FF'}
          phrase={'OKAY'}
          height={42}
          width={160}
        />
      </div>
    );
  }
}

export class MoxiCurrentActionView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { tall: false };
    this.handleDimensionChange = this.handleDimensionChange.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleDimensionChange);
    this.setState({ tall: isTall() });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleDimensionChange);
  }

  handleDimensionChange(event) {
    this.setState({ tall: isTall() });
  }

  render() {
    let { moxiCurrentAction } = this.props;
    let style = {
      color: '#2D9CA4',
      fontStyle: 'italic',
      width: '100%',
      justifyContent: 'center',
      fontWeight: 400,
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      alignSelf: 'center',
      fontSize: mobile ? 18 : 45,
      height: this.state.tall ? '3em' : '100%',
    };
    // Don't display any text if the robot is "idle" (awaiting next task)
    let message = moxiCurrentAction === ROBOT_IDLE_STATE ? `` : `Moxi is ${moxiCurrentAction}`;
    return <div style={style}>{message}</div>;
  }
}

export class OverlayView extends PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    let { onModalCloseAction } = this.props;
    return (
      <div style={{ ...Styles.container, backgroundColor: '#181C2F' }}>
        <div transparent={true} visible={true} onRequestClose={onModalCloseAction} presentationStyle="overFullScreen">
          {this.props.children}
        </div>
      </div>
    );
  }
}
